import React from "react";
import { Checkbox } from "antd";

const MatriceConflitti = ({ flussi, conflittiSelezionati, setConflittiSelezionati }) => {
  const manovreComplete = flussi
    .filter((f) => f.data?.saved)
    .map((f) => {
      const title = f.data?.title || "";
      const tipo = f.data?.inputType
        ? f.data.inputType.charAt(0).toUpperCase() + f.data.inputType.slice(1)
        : "";
      return tipo ? `${title} - ${tipo}` : title;
    });

  const handleToggle = (rowIdx, colIdx) => {
    const a = manovreComplete[rowIdx];
    const b = manovreComplete[colIdx];

    const pairKey = (x, y) => [x, y].sort().join("::");
    const pairSet = new Set(conflittiSelezionati.map(([x, y]) => pairKey(x, y)));

    const key = pairKey(a, b);
    const exists = pairSet.has(key);

    if (exists) {
      setConflittiSelezionati(
        conflittiSelezionati.filter(
          ([x, y]) => pairKey(x, y) !== key
        )
      );
    } else {
      setConflittiSelezionati([...conflittiSelezionati, [a, b]]);
    }
  };

  if (manovreComplete.length === 0) return <i>Nessuna manovra inserita.</i>;

  return (
    <div style={{ 
      maxHeight: "300px", 
      overflow: "auto",
      border: "1px solid #d9d9d9",
      borderRadius: "4px"
    }}>
      <div style={{ 
        overflowX: "auto",
        width: "fit-content",
        minWidth: "100%"
      }}>
        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
            textAlign: "center",
          }}
        >
          <thead>
            <tr>
              <th style={{ 
                position: "sticky", 
                top: 0, 
                left: 0, 
                background: "white",
                zIndex: 2,
                padding: 6, 
                border: "1px solid #ccc",
                minWidth: "200px"
              }}></th>
              {manovreComplete.map((title, idx) => (
                <th 
                  key={idx} 
                  style={{ 
                    position: "sticky", 
                    top: 0, 
                    background: "white",
                    zIndex: 1,
                    padding: 6, 
                    border: "1px solid #ccc",
                    minWidth: "200px"
                  }}
                >
                  {title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {manovreComplete.map((rowTitle, rowIdx) => (
              <tr key={rowIdx}>
                <td style={{ 
                  position: "sticky", 
                  left: 0, 
                  background: "white",
                  zIndex: 1,
                  padding: 6, 
                  border: "1px solid #ccc",
                }}>
                  <strong>{rowTitle}</strong>
                </td>
                {manovreComplete.map((colTitle, colIdx) => {
                  const key = [rowTitle, colTitle].sort().join("::");
                  const checked = conflittiSelezionati.some(
                    ([a, b]) => [a, b].sort().join("::") === key
                  );

                  return (
                    <td 
                      key={colIdx} 
                      style={{ 
                        padding: 6, 
                        border: "1px solid #ccc",
                        background: rowIdx === colIdx ? "#f5f5f5" : "white"
                      }}
                    >
                      {rowIdx !== colIdx ? (
                        <Checkbox
                          checked={checked}
                          onChange={() => handleToggle(rowIdx, colIdx)}
                        />
                      ) : null}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MatriceConflitti;
